import { render, staticRenderFns } from "./TesteWebSocket.vue?vue&type=template&id=31541cc2&scoped=true"
import script from "./TesteWebSocket.vue?vue&type=script&lang=js"
export * from "./TesteWebSocket.vue?vue&type=script&lang=js"
import style0 from "./TesteWebSocket.vue?vue&type=style&index=0&id=31541cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31541cc2",
  null
  
)

export default component.exports